import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'adminConfirmationPending',
    standalone: false
})
export class AdminConfirmationPendingPipe implements PipeTransform {
    transform(members) {
        return members.filter(
            (member) => member.membershipStatus === 'ADMIN_CONFIRMATION_PENDING'
        );
    }
}
